/** Tiny pub/sub so mock login changes can refresh favorites without circular imports. */
const listeners = new Set<() => void>();

export function onPresidioFavoritesLoginChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyPresidioFavoritesLoginChange(): void {
  listeners.forEach(listener => listener());
}
